import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultValue = {
  productsByTier: null,
  currencyCode: 'USD',
  selectedTerm: 'ANNUAL',
  renderPurchaseMotions: undefined,
  // no-op default keeps the quiz inert until a page provides a real callback.
  track: () => {},
  skipToResults: false,
  recommendationFetcher: undefined,
  designSystem: undefined
};
const PlanQuizDataContext = /*#__PURE__*/createContext(defaultValue);
export const PlanQuizDataProvider = ({
  value,
  children
}) => /*#__PURE__*/_jsx(PlanQuizDataContext.Provider, {
  value: value,
  children: children
});
export const usePlanQuizData = () => useContext(PlanQuizDataContext);